import React, { useState } from 'react';
import {
  Border,
  CollapsedItemWrapper,
  CollapsedPolicyWrapper,
  PolicyName,
  MoreVersions,
  IconWrapper,
} from './styled';
import { ArrowsAltOutlined, ShrinkOutlined } from '@ant-design/icons';
import ExpandedItem from './ExpandedItem';
import EarlierOrder from './EarlierOrder';
import { PolicyWrapper } from '@src/pages/Precision/common';
import { Tooltip } from 'antd';
import moment from 'moment-timezone';
import EditFilterButton from './EditFilterButton';
const CollapsedView = ({ policy, idx, sortable, resources, canEdit, order, originalOrder }) => {
  const [isItemExpanded, setExpanded] = useState(false);

  const onClickOfIcon = () => {
    setExpanded(!isItemExpanded);
  };

  return (
    <CollapsedPolicyWrapper data-id={policy.id} key={policy.id} sortable={sortable}>
      <Border />
      <CollapsedItemWrapper>
        <IconWrapper onClick={onClickOfIcon}>
          {isItemExpanded ? <ShrinkOutlined /> : <ArrowsAltOutlined />}
        </IconWrapper>
        <EarlierOrder policy={policy} idx={idx + 1} order={order} originalOrder={originalOrder} />
        <PolicyName>
          <span>
            <Tooltip title={policy.filter_text} placement="bottomLeft">
              {policy.filter_name}
            </Tooltip>
          </span>
          <span>{` / ${policy.versions[0].name}`}</span>
        </PolicyName>
        <MoreVersions>
          {policy.versions.length - 1 ? `+${policy.versions.length - 1} More. ` : ''}
          (Filter updated at {moment(policy.filter_updated).format('HH:mm:ss, MMM DD YYYY')}){' '}
          <EditFilterButton policy={policy} />
        </MoreVersions>
      </CollapsedItemWrapper>
      {isItemExpanded ? (
        <PolicyWrapper>
          <ExpandedItem
            policy={policy}
            sortable={sortable}
            resources={resources}
            canEdit={canEdit}
          />
        </PolicyWrapper>
      ) : null}
    </CollapsedPolicyWrapper>
  );
};

export default CollapsedView;
